import React, {
  Suspense,
  Fragment,
  lazy
} from 'react';
import {
  Switch,
  Redirect,
  Route
} from 'react-router-dom';
import DashboardLayout from './layouts/DashboardLayout';
import LoadingScreen from './components/LoadingScreen';
import GuestGuard from './components/GuestGuard';
import AuthGuard from './components/AuthGuard';

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;
        
        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>
                  {route.routes
                    ? renderRoutes(route.routes)
                    : <Component {...props} />}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
);

const routes = [
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('./views/auth/Login'))
  },
  {
    path: '*',
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/',
        component: lazy(() => import('./views/home'))
      },
      {
        exact: true,
        path: '/:merchantId/:branchId/:gateId/:ticketId',
        component: lazy(() => import('./views/service-fee'))
      },
      {
        exact: true,
        path: '/payment/:merchantId/:branchId/:gateId/:ticketId',
        component: lazy(() => import('./views/payment'))
      },
      {
        exact: true,
        path: '/payment-cash/:merchantId/:branchId/:gateId/:ticketId',
        component: lazy(() => import('./views/payment-cash'))
      },
      {
        exact: true,
        path: '/payment-qr/:paymentChannel/:merchantId/:branchId/:gateId/:ticketId',
        component: lazy(() => import('./views/payment-qr'))
      },
      {
        exact: true,
        path: '/payment-success/:paymentChannel/:merchantId/:branchId/:gateId/:ticketId/:invoiceNo',
        component: lazy(() => import('./views/payment-success'))
      },
      {
        exact: true,
        path: '/invoice/:paymentChannel/:merchantId/:branchId/:gateId/:ticketId/:invoiceNo',
        component: lazy(() => import('./views/invoice'))
      },
      // {
      //   exact: true,
      //   path: '/estamp',
      //   component: lazy(() => import('./views/estamp'))
      // },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];

export default routes;
